import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import AdminOnly from '../../components/admin-workspace/AdminOnly';

const ActivityLogs = lazy(() => import('../../container/settings/logs/ActivityLogs'));
const Setings = lazy(() => import('../../container/settings/access-control/Settings'));

function AccessControlRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/logs`} render={() => <AdminOnly><ActivityLogs /></AdminOnly>} />
      <Route path={`${path}`} render={(props) => <AdminOnly><Setings {...props} /></AdminOnly>} />
    </Switch>
  );
}

export default AccessControlRoutes;
